import { render, staticRenderFns } from "./inventory-diff.vue?vue&type=template&id=b2de7856"
import script from "./inventory-diff.vue?vue&type=script&lang=js"
export * from "./inventory-diff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports